import React from "react";
import $ from "jquery";
import store from "store";
import { notify } from "react-notify-toast";
import {
  Input,
  Modal,
  Row,
  Col,
  Button,
  Icon,
  Tabs,
  Tab,
} from "react-materialize";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";
import FontAwesome from "react-fontawesome";
import ReactTooltip from "simple-react-tooltip";
import { ShareButtons } from "react-share";

import {
  API_COURSE_BASE_URL,
  CheckAuth,
  FormatPrice,
  BASE_URL,
  API_PAYMENT,
} from "../Util";
import Page from "../Page";
import Image from "../Image";
import { trans, alert } from "../Lang";
import RatingModal from "../Reuseables/RatingModal";
import CourseItem from "./CourseItem";
import LearningPathItem from "./LearningPathItem";
import FloatingCourseBar from "./components/FloatingCourseBar";
import CourseHeader from "./components/CourseHeader";
import CourseModuleList from "./components/CourseModuleList";
import CourseContentResources from "./components/CourseContentResources";
import CourseConstants from "./Constants";

import "../../styles/course-rating-modal.css";
import "../../styles/course-detail.css";
import TransactionConstants from "../Transaction/Constants";

class CourseDetail extends Page {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      uuid: props.match.params.uuid,
      enrolling: props.match.params.enroll,
      redeem_coupon: CheckAuth().is_businessman === 0,
      content_rating: 0,
      media_rating: 0,
      benefit_rating: 0,
      comment: "",
    };
  }

  handleTypePin = (event) => {
    var charCode = parseInt(event.charCode);
    if (charCode != 13 && (charCode < 48 || charCode > 57))
      event.preventDefault();
  };

  handlePinChange = (e) => {
    const pinPattern = /^\d{6}$/;
    const errorMessage = !pinPattern.test(e.target.value)
      ? "PIN harus terdiri dari 6 digit angka"
      : "";
    this.setState({ errorMessage: errorMessage });
  };

  componentDidMount() {
    this.handleLoadData(this.state.enrolling);
    window.addEventListener("resize", this.updateDimensions);
    super.componentDidMount();
    $(".btn-help").hide();
  }

  componentDidUpdate(prevProps, prevState) {
    let activeTopic = this.state.topic;
    let { data } = this.state;
    let prevData = prevState.data || null;
    if (!prevState || prevState.topic !== activeTopic) {
      if (prevState && prevState.topic) {
        prevState.topic.selected = false;
      }
      activeTopic.selected = true;
      // console.log("DATA ACTIVE TOPIC>>> ", activeTopic);
      this.setState({ topic: activeTopic });
    }
  }

  componentWillReceiveProps(props) {
    let uuid = props.match.params.uuid;
    this.setState({ uuid: props.match.params.uuid, data: null });
    this.handleLoadData(this.state.enrolling, uuid);
  }

  updateDimensions = () => {
    this.setState({ width: $(window).width(), height: $(window).height() });
  };

  componentWillMount = function () {
    this.updateDimensions();
  };

  componentWillUnmount = function () {
    window.removeEventListener("resize", this.updateDimensions);
  };

  handleLoadData = (enroll, uuid, activeTopic = null) => {
    uuid = uuid ? uuid : this.state.uuid;

    $.getJSON(API_COURSE_BASE_URL + uuid).then((data) => {
      // console.log("DATA API_COURSE_BASE_URL >>> ", data);
      let { payload } = data;
      let topicUuid = window.location.hash.substring(1);
      let topic = activeTopic;
      if (!topic) {
        for (let i in payload.modules) {
          let topics = payload.modules[i].topics;
          if (topics.length > 0) {
            topic = topics[0];
            break;
          }
        }
      }
      let moduleIndex = 0;

      if (!!topicUuid) {
        for (let i in payload.modules) {
          let topics = payload.modules[i].topics;
          for (let j in topics) {
            if (topics[j] && topicUuid == topics[j].uuid && !topics[j].locked) {
              topic = topics[j];
              moduleIndex = i;
              break;
            }
          }
        }
      }

      if (topic) {
        topic.module_title = payload.modules[moduleIndex].title;
        topic.selected = true;
      }

      if (payload.voucher_redeemable) {
        payload.user_cashback = 0;
      }

      let alertSeen = store.get(this.getAlertKey());

      this.setState({
        data: payload,
        topic: topic,
        alert_seen: alertSeen,
      });

      $(".meta-title").attr("content", payload.title);
      $(".meta-image").attr("content", payload.thumbnail);
      $(".meta-description").attr("content", payload.description);

      if (enroll) {
        this.doEnroll();
      } else if (this.state.enrolling) {
        notify.show(
          `${trans.you} ${trans.successfully} ${trans.registered}`,
          "success"
        );
      }

      if (store.get(`completed_${uuid}`)) {
        store.remove(`completed_${uuid}`);
        $("#graduate-btn").trigger("click");
      }
    });
  };

  getAlertKey = () => {
    return "alert_seen_" + CheckAuth().email + "_" + this.state.uuid;
  };

  handleCloseAlert = () => {
    let alertKey = this.getAlertKey();
    store.set(alertKey, true);
    this.setState({ alert_seen: true });
  };

  doEnroll = (e) => {
    if (CheckAuth() === false) {
      this.setState({ enrolling: true });
      notify.show(
        `${trans.you} ${trans.must} ${trans.login} ${trans.first}`,
        "warning"
      );
      return;
    }

    $("#btn-modal-enroll").trigger("click");
    $(".loading").hide();
  };

  handleRedeem = (e) => {
    if (!this.checkLogin()) {
      return;
    }
    $("#btn-redeem").trigger("click");
    $(".loading").hide();
  };

  handleEnroll = (e, data) => {
    e.preventDefault();

    if (!CheckAuth()) {
      this.props.history.push(
        `/login?redirect=/course/${this.state.data.slug}`
      );
      return;
    }

    const { is_logged_in_user_allowed_to_enroll: isUserAllowed } = data;
    const {
      entity_type: entityType,
      program,
      smile_id: smileId,
    } = store.get("userdata");

    if (!isUserAllowed) {
      let message = "Pendaftaran kursus tidak berhasil.";
      message = `${message} ${
        smileId
          ? `Kursus ini tidak tersedia untuk tipe entitas dan program anda`
          : `Pendaftaran kursus ini tidak tersedia untuk akun Guest.`
      }`;
      notify.show(message, "warning");
      return;
    }

    let param = {
      method: TransactionConstants.TRANSFER,
      item_type: "course",
      item_quantity: 1,
      item_uuid: this.state.data.uuid,
      item_data: "",
      pin: "000000",
      coupon_code: "",
    };

    $.post(API_PAYMENT, param)
      .then((data) => {
        if (data.status == "success") {
          this.props.history.push(
            `/transactions/${data.payload.invoice_number}`
          );
        } else {
          notify.show(data.message, "warning");
        }
      })
      .fail((XMLHttpRequest, textStatus, errorThrown) => {
        try {
          let response = JSON.parse(XMLHttpRequest.responseText);
          if (response && response.status) {
            this.setState({ errorMessage: response.message });
            notify.show(response.message, "warning");
          }
        } catch (e) {
          console.error(e);
        }
      });
  };

  finishEnroll = (redirectUrl) => {
    $(".modal-close").trigger("click");
    $(".loading").hide();
    this.props.history.push(redirectUrl);
  };

  handleClick = (i, j, locked, e) => {
    super.scrollToTop();
    let module = this.state.data.modules[i];
    let topic = module ? module.topics[j] : null;
    let message = this.state.data.enrolled ? (
      <span>{`${trans.you} ${trans.must} ${trans.finish} ${trans.chapter} sebelumnya ${trans.first}`}</span>
    ) : (
      <span>{`${trans.you} ${trans.must} ${trans.register} ${trans.first}`}</span>
    );

    if (locked) notify.show(message, "warning");
    else {
      if (module) {
        topic.module_title = module.title;
        topic.selected = true;
        this.setState({ topic: topic });
        $(".hls-player").attr("autoplay", "autoplay");
      } else {
        notify.show(i + " : " + j + " :" + locked);
      }
    }

    if (
      this.state.width < 800 ||
      (topic && topic.resource_type == CourseConstants.TYPE_QUIZ)
    )
      super.scrollToTop();
    e.preventDefault();
  };

  handlePinChange = (e) => {
    var errorMessage = !pinPattern.test(e.target.value)
      ? alert.invalid_pin_digit
      : "";
    var pinPattern = /^\d{6}$/;
    this.setState({ errorMessage: errorMessage });
  };

  handleTypePin = (event) => {
    var charCode = parseInt(event.charCode);
    if (charCode != 13 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  };

  onMediaAction = (topic, action) => {
    super.scrollToTop();
    let { uuid } = this.state;
    let url_link = API_COURSE_BASE_URL + uuid + "/progress";
    let param = {
      topic_uuid: topic.uuid,
      action: action,
    };

    this.setTopicStatus(topic, action);

    if (action != 3) {
      return false;
    }

    $.post(url_link, param)
      .then((data) => {
        // console.log(data);
        // load data
        if (action == "3") {
          this.handleLoadData("", "", topic);
        }
      })
      .fail(() => {
        console.log("Module progress not sent due to error");
      });
  };

  setTopicStatus = (topic, action) => {
    if (action === CourseConstants.COURSE_ENDED) {
      topic.completed = true;
      this.setState({ topic: topic });
    } else if (
      action === CourseConstants.COURSE_PLAYED ||
      action === CourseConstants.COURSE_PAUSED
    ) {
      topic.selected = true;
      this.setState({ topic: topic });
    }
  };

  getRedeemCouponModal = (data) => {
    return (
      <form onSubmit={(e) => this.handleEnroll(e, data)} className="mb-0 row">
        <img className="mb-s" src={BASE_URL + "/img/logo-paytren-black.png"} />
        <h5>Beli Menggunakan Kupon</h5>
        <div className="mb-s">
          Dengan menekan tombol “Redeem”, Anda akan langsung terdaftar pada{" "}
          {trans.course} ini.
        </div>
        <Input
          autocomplete="off"
          id="coupon_code"
          label="Masukkan Kode Kupon"
          s={12}
          required
        />
        <Col s={12} className="error-msg font-red strong mnt-s">
          {this.state.errorMessage}
        </Col>
        <Input
          autocomplete="off"
          onChange={this.handlePinChange}
          onKeyPress={this.handleTypePin}
          id="pin"
          maxLength="6"
          type="password"
          pattern="[0-9]{6}"
          s={12}
          value="000000"
          required
          disabled
          hidden
        />

        <a
          className="link strong"
          data-tip={`Kupon berisi kode yang dapat ditukarkan dengan ${trans.course_item}. Satu kupon hanya dapat ditukar dengan 1 ${trans.course_item} dan tidak dapat digunakan kembali.`}
        >
          Apa itu kupon ?
        </a>
        <ReactTooltip place="right" />
        <br />
        <br />
        <Button id="enroll-btn" s={12} className="full" waves="light">
          REDEEM
        </Button>
      </form>
    );
  };

  render() {
    var data = this.state.data;
    var activeTopic = this.state.topic;
    var isMobile = this.state.width && this.state.width < 800;

    let rating_specs = [
      { topic: "Materi Kursus", name: "rating_content", item: "modul" },
      { topic: "Kualitas Media", name: "rating_media", item: "modul" },
      {
        topic: "Benefit yang Anda rasakan",
        name: "rating_benefit",
        item: "modul",
      },
    ];

    let comment_rating_specs = [
      {
        title: "Tuliskan Masukan Anda",
        placeholder: "Masukan Anda",
        name: "user_comment",
        rows: 6,
      },
    ];

    if (
      this.state.session_expired ||
      (CheckAuth() === false && this.state.enrolling)
    )
      return <Redirect to={"/login?redirect=" + window.location.pathname} />;
    if (!data) {
      return super.render();
    }

    let shareUrl = window.location.origin + `/course.php?uuid=${data.uuid}`;
    let shareContent = `${trans.course} ${data.title} oleh ${data.instructor}`;
    const { FacebookShareButton, TwitterShareButton } = ShareButtons;

    return (
      <div className="bg-white">
        <RatingModal
          header="Review Kursus"
          rating_specs={rating_specs}
          comment_specs={comment_rating_specs}
          modal_name="course_rating"
          is_open={
            store.get("review_modul")
              ? store.get("review_modul") === this.state.uuid
              : data.ask_to_review || false
          }
          api_url={API_COURSE_BASE_URL + this.state.data.uuid + "/review"}
          callback={this.handleLoadData}
          rest={{
            courseTitle: data.title,
            reviews:
              data.reviews && data.reviews.length ? data.reviews[0] : null,
            hasReviewed: data.has_reviewed,
          }}
        />

        <FloatingCourseBar
          data={data}
          errorMessage={this.state.errorMessage}
          isMobile={isMobile}
          onEnroll={(e) => this.handleEnroll(e, data)}
          onRedeem={this.handleRedeem}
        />
        <div className="container narrow">
          {data.locked && !this.state.alert_seen && (
            <div className="bg-orange font-white pad-m valign-wrapper">
              <div className="full">
                <span>
                  <span>
                    Maaf, untuk melanjutkan {trans.course} ini Anda harus
                    menyelesaikan{" "}
                  </span>
                  <Link
                    className="link strong"
                    to={`/course/${data.required_course.uuid}`}
                  >
                    syarat {trans.course_item}{" "}
                  </Link>
                  <span>terlebih dahulu</span>
                </span>
              </div>
              <a onClick={this.handleCloseAlert} className="right">
                <Icon small>clear</Icon>
              </a>
            </div>
          )}

          <div className="row mb-0 mt-m" id="course-body">
            {!isMobile && (
              <div className="col s4" style={{ paddingRight: "32px" }}>
                <CourseHeader title={data.title} instructor={data.instructor} />
                <CourseModuleList
                  data={data}
                  activeTopic={activeTopic}
                  handleClickTopic={this.handleClick}
                />
              </div>
            )}

            <div
              className={
                isMobile
                  ? "col s12 border-left pb-m"
                  : "col s8 border-left pb-m"
              }
            >
              <CourseContentResources
                key={activeTopic ? activeTopic.uuid : null}
                data={data}
                topicList={this.state.topic}
                activeTopic={activeTopic || {}}
                thumbnail={data.thumbnail}
                onMediaAction={this.onMediaAction}
              />

              <Tabs className="tabs-detail mt-s">
                <Tab title={trans.about} active>
                  <div className="pad-m">
                    {data.enrolled && (
                      <b className="font-grey">
                        Anda sudah terdaftar dalam {trans.course_item} ini{" "}
                        <br />
                      </b>
                    )}
                    {/* <div className="detail-title">{data.title}</div> */}
                    <div
                      className="mt-xs detail-title"
                      style={{ fontSize: "20px" }}
                    >
                      {data.title}
                    </div>

                    <div
                      dangerouslySetInnerHTML={{ __html: data.description }}
                    />

                    <div className="mt-xs detail-title">
                      {trans.number_chapter}
                    </div>
                    <div>{data.modules.length} Chapter</div>

                    <hr />

                    <div>{trans.access_info_course}</div>
                    <div className="mt-xs detail-title">
                      {trans.entity_type}
                    </div>
                    <div>
                      {data.entity_types.length > 0
                        ? data.entity_types.map((opt) => opt.name).join(", ")
                        : "Semua"}
                    </div>
                    <div className="mt-xs detail-title">Program</div>
                    <div>
                      {data.programs.length > 0
                        ? data.programs.map((opt) => opt.name).join(", ")
                        : "Semua"}
                    </div>

                    <hr />

                    {data.is_accessible_by_guest ? (
                      <div>{trans.access_info_course_guest}</div>
                    ) : null}

                    {/* <Row>
                      {true && (
                        <Col l={6} m={6} s={6}>
                          <h6 className="price-type">Harga</h6>
                          <span id="course-price" className="font-heavy">
                            {data.price === 0
                              ? "GRATIS"
                              : FormatPrice(data.price)}
                          </span>
                        </Col>
                      )}
                    </Row> */}

                    {/* {data.category && (
                      <Link
                        to={`/course/catalog?category_id=${data.category.id}`}
                      >
                        <span className="lp-detail-ctg mr-xs mt-s pad-xs-m">
                          {data.category.name}
                        </span>
                      </Link>
                    )} */}
                    {/* <hr />
                    {data.instructor_avatar && (
                      <Image
                        src={data.instructor_avatar}
                        className="left small circle mr-s"
                      />
                    )}
                    <b>{data.instructor}</b>
                    <br />
                    {data.instructor_detail}
                    <hr className="mt-sxs" /> */}

                    {data.course_journey && <b>{trans.learning_path}</b>}
                    <br />
                    {data.course_journey && (
                      <span>
                        {trans.course} ini termasuk dalam kumpulan{" "}
                        {trans.learning_path} berikut.
                      </span>
                    )}
                    {data.course_journey && (
                      <LearningPathItem data={data.course_journey} />
                    )}
                  </div>
                </Tab>

                {data.required_courses && (
                  <Tab
                    className={data.required_courses.length == 0 ? "hide" : ""}
                    title="Syarat Modul"
                  >
                    <div className="pad-m">
                      <div className="strong font-grey mb-m">
                        Anda harus menyelesaikan Modul berikut terlebih dahulu
                        secara berurutan
                      </div>
                      {data.required_courses.map((course, i) => (
                        <div className="valign-wrapper border-bottom mb-s">
                          <div className="mnt-s">
                            {course.completed && (
                              <div className="badge-check left lh-50">
                                <Icon className="icon-course">
                                  check_circle
                                </Icon>
                              </div>
                            )}

                            {!course.completed && (
                              <div className="badge left center lh-50">
                                {i + 1}
                              </div>
                            )}
                          </div>
                          <CourseItem
                            hideInstructor="true"
                            className="section-card"
                            data={course}
                          />
                        </div>
                      ))}

                      {data.required_courses.length == 0 && (
                        <div className="pad-xl center">
                          <img src={BASE_URL + "/img/profile/ic-riwayat.png"} />
                          <br />
                          <br />
                          <div className="strong font-grey">
                            {trans.course} ini tidak memiliki syarat
                          </div>
                        </div>
                      )}
                    </div>
                  </Tab>
                )}

                <Tab className={!isMobile ? "hide" : ""} title="Materi">
                  {isMobile && (
                    <CourseModuleList
                      data={data}
                      activeTopic={activeTopic}
                      handleClickTopic={this.handleClick}
                    />
                  )}
                </Tab>
              </Tabs>
            </div>

            {/* <Col s={12} className="pad-m bg-grey">
               <div className="center-align">
                <span className="h5 font-grey mr-s">{trans.share_to}</span>
                <FacebookShareButton
                  className="btn btn-circle mr-xs"
                  url={shareUrl}
                  title={shareContent}
                >
                  <FontAwesome name="facebook" />
                </FacebookShareButton>
                <TwitterShareButton
                  className="btn btn-circle mr-xs"
                  url={shareUrl}
                  title={shareContent}
                >
                  <FontAwesome name="twitter" />
                </TwitterShareButton>
              </div>
            </Col>*/}
          </div>
        </div>

        <Modal
          trigger={
            <Button id="graduate-btn" className="hide">
              SUBMIT
            </Button>
          }
        >
          <div className="center almost-full">
            <h4>Selamat Anda Telah Menyelesaikan {trans.course} Ini </h4>
            <img
              className="mt-s mb-m"
              src={BASE_URL + "/img/ic_medallion.png"}
            />
            <div className="mb-m">
              Anda telah menyelesaikan seluruh {trans.chapter} dari{" "}
              {trans.course} ini. Kami memberikan sertifikat sebagai bukti Anda
              telah lulus melewati pembelajaran.
            </div>
            <Link to={`/course/${data.slug}/recap`} className="btn modal-close">
              Rekap Nilai
            </Link>
            <h4 />
          </div>
        </Modal>
        <Modal trigger={<Button className="hide" id="btn-redeem" />}>
          {this.getRedeemCouponModal(data)}
        </Modal>
      </div>
    );
  }
}

export default CourseDetail;



// WEBPACK FOOTER //
// ./src/components/Course/Detail.js